<div class="login-container">
  <!-- Stesso background della pagina login (coerenza visiva del flow auth) -->
  <div class="custom-login background-image"></div>

  <div class="form-wrapper">
    <div class="login-card">
      <div class="login-card__logo">
        <img src="assets/icons/logo-diakonix-black.png" alt="Diakonix" />
      </div>

      <header class="login-card__header">
        <h1 class="login-card__title">Recupera password</h1>
        <p class="login-card__subtitle">
          Inserisci il tuo indirizzo email per ricevere la tua nuova password.
        </p>
      </header>

      <form
        class="login-form"
        [formGroup]="resetForm"
        (ngSubmit)="resetPassword(resetForm.value)"
        autocomplete="on"
        novalidate
      >
        <div class="login-form__field">
          <label for="reset-email" class="login-form__label">Email</label>
          <input
            id="reset-email"
            type="email"
            class="login-form__input"
            formControlName="username"
            placeholder="nome@azienda.it"
            autocomplete="username"
            required
          />
          @if (
            (resetForm.get('username')?.touched || resetForm.get('username')?.dirty) &&
            resetForm.get('username')?.errors
          ) {
            <div class="login-form__error">Email mancante o non valida</div>
          }
        </div>

        <button
          type="submit"
          class="login-form__submit"
          [disabled]="!resetForm.valid || disabledButton"
        >
          @if (disabledButton) {
            <span>Invio in corso…</span>
          } @else {
            <span>Invia email</span>
          }
        </button>

        <a routerLink="/login" class="login-form__link">
          ← Torna al login
        </a>
      </form>
    </div>
  </div>
</div>
